import React, { ReactElement, useEffect, useState } from 'react'
import { ContainerFormulario } from '@pages/style'
import { Row, Col, Typography, message, Button, Spin, Table } from 'antd'
import { HeaderPage, Input, InputMasked, Select } from '@components/atoms'
import { useRouter } from '@customHooks'
import { useForm } from 'react-hook-form'
import api from '@services/api'
import { SaveOutlined } from '@ant-design/icons'

export default function FormularioServicos(): ReactElement {
  const {
    navigate,
    state,
    params: { id },
  } = useRouter<'id'>()
  const { control, reset, handleSubmit } = useForm()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (id && state) {
      reset({ ...(state as object) })
    }
  }, [state, id])

  const onSubmit = () => {
    handleSubmit(async (values) => {
      setLoading(true)
      id
        ? await api
            .put(`/servicos/${id}`, values)
            .then(() => {
              setLoading(false)
              message.success('Serviço atualizado com sucesso!')
              navigate('/vendas/servicos')
            })
            .catch(() => setLoading(false))
        : await api
            .post('/servicos', values)
            .then(() => {
              setLoading(false)
              message.success('Serviço cadastrado com sucesso!')
              navigate('/vendas/servicos')
            })
            .catch(() => setLoading(false))
    })()
  }

  return (
    <ContainerFormulario>
      <HeaderPage
        title={id ? 'Atualizar Serviço' : 'Novo Serviço'}
        onBack={() => navigate(-1)}
        extra={[
          <Button
            key='salvar'
            icon={<SaveOutlined />}
            type='primary'
            size='large'
            loading={loading}
            onClick={onSubmit}
          >
            Salvar
          </Button>,
        ]}
      />
      <form>
        <Spin spinning={loading}>
          <Row gutter={[12, 12]} align='bottom'>
            <Col span={16}>
              <Typography.Title level={5}>Descrição</Typography.Title>
              <Input
                control={control}
                name='DESCSERVICO'
                placeholder='Descrição'
              />
            </Col>
            <Col span={4}>
              <Typography.Title level={5}>
                % Sobre preço do produto
              </Typography.Title>
              <InputMasked
                control={control}
                name='PERCPRECO_PRODUTO'
                placeholder='% Sobre preço do produto'
                suffix={'%'}
                decimalScale={2}
                isAllowed={(val) => {
                  if (val.floatValue) {
                    return val.floatValue <= 100
                  } else {
                    return true
                  }
                }}
              />
            </Col>
            <Col span={4}>
              <Typography.Title level={5}>
                Valor por unidade do produto
              </Typography.Title>
              <Input
                control={control}
                name='VALOR_PRODUTO'
                placeholder='Valor por unidade do produto'
              />
            </Col>
          </Row>
        </Spin>
      </form>
    </ContainerFormulario>
  )
}
